import { AxiosResponse } from 'axios';
import API from 'services/API';
import useAppMutation from 'hooks/useAppMutation';
import {
  LeadSearchWithMessages,
  LeadsSearchResponse,
} from './LeadSearchField.types';

const searchLeads = async ({
  query,
  withMessages,
}: {
  query: string;
  withMessages?: LeadSearchWithMessages;
}) => {
  const response: AxiosResponse<LeadsSearchResponse> = await API.get(
    `/api/internal/leads/search?query=${encodeURIComponent(query)}${
      withMessages ? `&withMessages=${withMessages}` : ''
    }`,
  );

  return response.data.leads || [];
};

const useLeadSearchMutation = () => {
  return useAppMutation({
    mutationFn: searchLeads,
  });
};

export default useLeadSearchMutation;
